<script>
    export default {
        /////////////////////////////////////////////////////
        // Data
        /////////////////////////////////////////////////////
        data() {
            return {
              showDropdown: false
            }
        },
        /////////////////////////////////////////////////////
        // Props
        /////////////////////////////////////////////////////
        props: {
            'step': {
                type: Number,
                default: 0
            },
            'dataLoaded': {
                type: Boolean,
                default: false
            }
        },
        watch: {
            step: function (val) {
                switch (val) {
                    case 3:
                        if (window.innerHeight < 950) {
                            $('html, body, .nav-menu').animate({scrollTop: 200}, 'slow')
                        }
                        break
                }
            }
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        methods: {
            nextPage() {
                if (this.step == 3) {
                    window.location = '15.html'
                }
            },
            nextStep() {
                this.$emit('next', parseInt(this.step) + 1);
            },
            prevStep() {
                this.$emit('prev', parseInt(this.step) - 1);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// _vue/components/Page-14.vue